export default __webpack_public_path__ + "static/media/c1logo.fce29429.png";